import * as z from "zod/v4";

/**
 * One-click print buy-labels entry point. Unlike {@link buyLabels}, the
 * client doesn't supply fulfillment group IDs, shipping rates, or line
 * items — only how many orders to purchase. The server re-resolves the
 * optimized batch (priority filters → general pool) at purchase time so
 * concurrent activity by other users in the same team can't hand back
 * already-bought groups.
 *
 * Shipping rates and line items are derived server-side from each
 * resolved group's stored state.
 */
export const buyPriorityFilterLabels = {
  name: "buyPriorityFilterLabels" as const,
  input: z.object({
    limit: z.number().int().positive(),
    userId: z.string(),
    print: z.boolean(),
    templateId: z.string().nullish(),
    fulfillmentDate: z.date().nullish(),
    notifyMarketplace: z.boolean().nullish(),
    initiationTime: z.number().nullish(),
  }),
  output: z.object({ batchId: z.string(), batchNumber: z.string() }),
};
